import { ExternalAccountInvitation, LanguageNameSpaces } from "@shared/types";
import Dropdown from "common/Dropdown/Dropdown.tsx";
import { IconWrapper } from "features/trades/common/styles.tsx";
import EllipsisOutlined from "@ant-design/icons/EllipsisOutlined";
import styled from "styled-components";
import CreateInvitationModal from "features/configuration/InviteExternalUsers/CreateInvitationModal.tsx";
import { useInvitationActions } from "features/configuration/InviteExternalUsers/hooks.tsx";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface InvitationActionsProps {
  invitationData: ExternalAccountInvitation;
}

const InvitationActions = ({ invitationData }: InvitationActionsProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.PORTFOLIO);
  const { actionsItems, editModalOpen, setEditModalOpen } =
    useInvitationActions(invitationData);

  return (
    <>
      <Dropdown
        title={t("invitations.invitation_actions")}
        menu={{ items: actionsItems }}
        trigger={["click"]}
      >
        <IconWrapper>
          <StyledEllipsisOutlined />
        </IconWrapper>
      </Dropdown>
      <CreateInvitationModal
        open={editModalOpen}
        onCancel={() => setEditModalOpen(false)}
        invitation={invitationData}
      />
    </>
  );
};

export default InvitationActions;

const StyledEllipsisOutlined = styled(EllipsisOutlined)<{ $iconSize?: number }>`
  transform: rotate(90deg);
  font-size: 30px;
  cursor: pointer;
  color: ${(p) => p.theme.colors.basic};
`;
